export default __webpack_public_path__ + "static/soehne-web-extraleicht-b78e1f17c8397ff5cab57a02bc6c8fc2.woff2";